// 常量
import { ColumnType } from "antd/lib/table";
import { EditDynamicSubTableProps } from "../interface";

function useColumnsHook(options: {
  /** 组件属性props */
  props: EditDynamicSubTableProps;
  /** 是否为子表 */
  isChildren?: boolean;
}) {
  const {
    props: {
      mainColumns,
    },
  } = options;
  const columns: ColumnType<any>[] = [];
  mainColumns?.forEach((column, index) => {
    const {
      title,
      dataIndex,
      editable,
      formItemType,
      initialValue: outInitialValue,
      ...restColumns
    } = column;
    const baseColumn: ColumnType<any> = {
      title,
      dataIndex,
      ...restColumns
    };
    if (editable) {
      columns.push({
        ...baseColumn,
        onCell: (record: any, rowIndex?: number) => {
          let initialValue: any;
          if (typeof dataIndex === 'string') {
            initialValue = record[dataIndex];
          }
          if (
            formItemType === 'SuperSelectTable' &&
            Array.isArray(dataIndex)
          ) {
            initialValue = record[dataIndex[0]];
          }
          if (!initialValue && outInitialValue !== undefined) {
            initialValue = outInitialValue;
          }
          const trProps: any = {
            record,
            rowIndex,
            formItemType,
            editable: true,
            name: dataIndex,
            simpleFormItemProps: {
              label: title,
              initialValue,
            },
          };
          return trProps;
        },
      });
    } else {
      columns.push({
        ...baseColumn,
      });
    }
  });
  return {
    columns,
  };
}

export default useColumnsHook;
